import { render, staticRenderFns } from "./FirstWorkspace.vue?vue&type=template&id=35a814c8&"
import script from "./FirstWorkspace.vue?vue&type=script&lang=js&"
export * from "./FirstWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./FirstWorkspace.vue?vue&type=style&index=0&id=35a814c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports